// 천 단위 구분
export const formatNumber = (value: number | string) => value.toLocaleString('ko-KR');

// 원화 포맷팅
export const formatKRW = (value: number) => `${value.toLocaleString('ko-KR')}원`;

// 퍼센트 포맷팅
export const formatPercent = (value: number, decimals = 1) => `${value.toFixed(decimals)}%`;

// 소수점 자릿수 제한
export const formatDecimal = (value: number, decimals = 2) => Number(value.toFixed(decimals)).toLocaleString('ko-KR');
// 소수점 자릿수 제한
export const formatCell = (e: React.ChangeEvent<HTMLInputElement>) => {
	const value = e.target.value.replace(/\D/g, ''); // 숫자만 남기기

	if (value.length <= 3) {
		return value;
	} else if (value.length <= 7) {
		return `${value.slice(0, 3)}-${value.slice(3)}`;
	} else {
		return `${value.slice(0, 3)}-${value.slice(3, 7)}-${value.slice(7, 11)}`;
	}
};

// 숫자만 입력
export const formatNumberOnly = (e: React.ChangeEvent<HTMLInputElement>) => e.target.value.replace(/[^0-9]/g, '');
export const formatBytesToKB = (bytes: number) => `${Math.round(bytes / 1024)} KB`;
